import { ChevronRight } from 'lucide-react'
import * as React from 'react'

import { useSpEditorProvider } from '@/features/screenplay/components/editor/SpEditorProvider'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/shared/components/ui/collapsible'
import { ScrollArea } from '@/shared/components/ui/scroll-area'
import {
    Sidebar,
    SidebarContent,
    SidebarGroupLabel
} from '@/shared/components/ui/sidebar'
import { useStoryboardStore } from '../store/useStoryboardStore'

import { cn } from '@/shared/lib/utils'
import { useSceneStore } from '@/features/shared/stores/scene.store'
import { getSceneHeader } from '@/shared/utils/editor-utils'
import { SceneCard } from '@/features/shared/components/SceneCard'

export default function SbOptionBar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { scenes, editor } = useSceneStore()
    const { selectScene, selectedSceneNode } = useStoryboardStore()
    const selectedSceneId = selectedSceneNode?.id

    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden h-svh border-l lg:flex"
            side="right"
            {...props}
        >
            <SidebarContent>
                <Collapsible
                    defaultOpen={true}
                    className="group/collapsible flex flex-col flex-grow min-h-0 pt-4"
                >
                    <SidebarGroupLabel
                        asChild
                        className="group/label text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground w-full text-sm px-4"
                    >
                        <CollapsibleTrigger>
                            Scenes
                            <ChevronRight className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
                        </CollapsibleTrigger>
                    </SidebarGroupLabel>
                    <CollapsibleContent className="flex flex-col flex-grow min-h-0">
                        <ScrollArea className="flex-grow min-h-0">
                            <div className="p-4 font-script flex flex-col gap-1.5">
                                {scenes.map((scene, index) => {
                                    const text = editor?.read(() => getSceneHeader(scene as any));
                                    const isSelected = selectedSceneId === scene.id;

                                    return (
                                        <SceneCard
                                            key={scene.id || index}
                                            index={index + 1}
                                            title={text}
                                            isSelected={isSelected}
                                            onClick={() => selectScene(scene as any)}
                                        />
                                    );
                                })}
                            </div>
                        </ScrollArea>
                    </CollapsibleContent>
                </Collapsible>
            </SidebarContent>
        </Sidebar>
    )
}
